import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown",
    ref: "dropdownRef",
    onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
    onClick: _cache[4] || (_cache[4] = ($event: any) => (!_ctx.openOnHover && _ctx.toggleDropdown($event)))
  }, [
    _createElementVNode("div", {
      style: {"display":"flex"},
      class: _normalizeClass({ open: _ctx.isOpen })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "menuRef",
            class: _normalizeClass(["options-wrapper", { mobile: _ctx.isMobile || _ctx.isTablet }]),
            style: _normalizeStyle(_ctx.dropdownStyle),
            onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
            onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
          }, [
            _createElementVNode("ul", {
              class: _normalizeClass({ 'mobile-list': _ctx.isMobile || _ctx.isTablet })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: option.key,
                  onClick: ($event: any) => (_ctx.selectOption(option)),
                  class: _normalizeClass(["item", {
              selected: option.key === _ctx.selected,
            }])
                }, [
                  (option.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
                        key: 0,
                        class: "icon"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(option.label), 1)
                ], 10, _hoisted_1))
              }), 128))
            ], 2)
          ], 38))
        : _createCommentVNode("", true)
    ]))
  ], 544))
}